import TableExport from 'tableexport'

TableExport.prototype.typeConfig.date.assert = function (value) { return false }
TableExport.prototype.typeConfig.number.assert = function (value) {
  if (value.match(/^-?\d+$/)) {
    // valid integer
    return true
  } else if (value.match(/^\d+\.\d+$/)) {
    // valid float
    return true
  } else {
    // not valid number
    return false
  }
}

var XMLGenerator = function () {
  var self = this
  this.generateExcel = function (table) {
    var result = {}
    var exportedTable = TableExport(table, {
      formats: ['xlsx', 'xls'],
      filename: '表單'
    })
    result = {
      xlsxData: exportedTable.getExportData()[table.id].xlsx,
      exportedTable: exportedTable
    }
    return result
  }
  this.generate = function (datas, headerList, typeList) {
    if (!typeList) typeList = []
    var result = {}
    // 1. 根據資料，產生table
    var table = document.createElement('table')
    // 1-1. header
    var thead = document.createElement('thead')
    let tr = document.createElement('tr')
    for (var header of headerList) {
      var th = document.createElement('th')
      th.innerText = header
      tr.appendChild(th)
    }
    thead.appendChild(tr)
    table.appendChild(thead)
    // 1-2 rows
    var tbody = document.createElement('tbody')
    for (var row of datas) {
      let tr = document.createElement('tr')
      for (var i = 0; i < row.length; i++) {
        var col = row[i]
        var dataType = typeList[i] || 'string'
        var td = document.createElement('td')
        td.innerText = col
        td.className = `tableexport-${dataType}`
        tr.appendChild(td)
      }
      tbody.appendChild(tr)
    }
    table.appendChild(tbody)

    // 2. 將此table 使用uniqueid append到body
    var tempID = 'temp-table-' + (new Date().getTime())
    table.id = tempID
    table.style.display = 'none'
    document.body.appendChild(table)

    // 3. 產生xlsx...
    result = self.generateExcel(table)
    // 4. 移除table
    table.remove()
    return result
  }
}
export default XMLGenerator
